import { masterAgentApi } from './index';

const masterAgentService = {
  getAllQuotes(params) {
    return masterAgentApi.get('my-quotes', { params });
  },
  getAllComissions(params) {
    return masterAgentApi.get('my-comissions', { params });
  },
  getAllOrders(params) {
    return masterAgentApi.get('my-orders', { params });
  },
  getAllContracts(params) {
    return masterAgentApi.get('contracts', { params });
  },
  getProducts(id) {
    return masterAgentApi.get(`master-agent/get-products/${id}`);
  },
  saveFormOpportunity(payload) {
    return masterAgentApi.post('opportunities/save', payload)
  },
  getOpportunities(params) {
    return masterAgentApi.get('opportunities/get', params)
  },
  resendEmailOpportunity({ id }) {
    return masterAgentApi.get(`opportunities/resend/${id}`, {})
  }
};

export default masterAgentService;